import styled from 'styled-components'; 

export const FeedGalleryListBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    // justify-content: center;
    height: fit-content;
`;
export const FeedNotExistTxtBlock = styled.div`
    background: #f7f7f7;
    height: 100%;
    padding: calc(100vw * (16 / 375)) calc(100vw * (15 / 375));
`;

export const FeedNotExistTxt = styled.p`
    color: #c6c6c6;
    font-size: calc(100vw * (14 / 375));
`;

export const FeedGalleryItemLink = styled.span`
    padding: 0 calc(100vw*(2/375)) 0 0;
    margin-bottom: calc(100vw*(2/375));
    flex: 0 0 33.33%;
    height: calc(100vw*(124/375));

    &:nth-child(3n) {
        padding-right: 0 ;
    }
`;